
export * from '../../frontend-taglib-clay/__liferay__/exports/@clayui$nav.js';

import __default__ from '../../frontend-taglib-clay/__liferay__/exports/@clayui$nav.js';
export default __default__;
